import { render, staticRenderFns } from "./MyDrawer.vue?vue&type=template&id=652508d8&"
import script from "./MyDrawer.vue?vue&type=script&lang=js&"
export * from "./MyDrawer.vue?vue&type=script&lang=js&"
import style0 from "./MyDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports